import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { Container, Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '@stores/usersSlice';
import SupportOffline from './components/SupportOffline';
import { Permissions, Views } from './constants';
import BellNotification from '@components/Common/BellNotification/BellNotification';
import { logout } from './keycloak';
import { AwpDropdownMenuItem, AwpNavDropdown } from '@components/AwpMenuItem';

const TopHeader = ({ user, expandedClick, isBarExpanded = false }) => {
  const storedUser = useSelector(selectCurrentUser);
  const currentUser = user ?? storedUser;

  return (
    <>
      <header>
        <Navbar variant="light" bg="light" expand="lg" className="main-nav">
          <Container className="justify-content-between">
            <div className="d-flex align-items-center">
              {' '}
              {/* Add a flex container */}
              <Navbar.Brand href="https://www2.gov.bc.ca">
                <img
                  className="img-fluid d-none d-md-block"
                  src="/assets/images/bcid-logo-en.svg"
                  width="150"
                  height="39.67"
                  alt="B.C. Government Logo"
                />
                <img
                  className="img-fluid d-md-none"
                  src="/assets/images/bcid-symbol-rev.svg"
                  width="64"
                  height="44"
                  alt="B.C. Government Logo"
                />
              </Navbar.Brand>
              <Navbar.Brand href="/" className="header_title d-none d-md-inline-block">
                Snow Avalanche and Weather System
              </Navbar.Brand>
              <Navbar.Brand href="/" className="header_title d-md-none">
                SAWS X
              </Navbar.Brand>
            </div>
            <Nav className="align-items-center">
              <BellNotification title="Notifications" />
              <SupportOffline supportOffline={false}>
                <div className="flex-grow-1 text-right d-lg-none">
                  <button
                    className="navbar-toggler"
                    style={{ fontSize: '16px' }}
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarNavAltMarkup"
                    aria-controls="navbarNavAltMarkup"
                    aria-label="Toggle navigation"
                    onClick={() => expandedClick?.()}
                  >
                    {isBarExpanded ? (
                      <span>
                        Close
                        <i className="fa fa-times p-2" aria-hidden="true" />
                      </span>
                    ) : (
                      <span>
                        Menu
                        <i className="fa fa-bars p-2" aria-hidden="true" />
                      </span>
                    )}
                  </button>
                </div>

                <div className="flex-grow-1 text-right d-none d-lg-block">
                  <AwpNavDropdown id="navbarDropdownUser" title={currentUser.UserName} supportOffline={false}>
                    <AwpDropdownMenuItem
                      title="My Profile"
                      to={Views.MyProfile}
                      permissions={[Permissions.ReadUserDashboard]}
                      onClick={() => expandedClick()}
                    />
                    <AwpDropdownMenuItem
                      title="My Preferences"
                      to={Views.UserPreferences}
                      permissions={[Permissions.ReadUserDashboard]}
                      onClick={() => expandedClick()}
                    />
                    <AwpDropdownMenuItem
                      to="/"
                      title="Sign out"
                      permissions={[Permissions.ReadUserDashboard]}
                      onClick={logout}
                    />
                  </AwpNavDropdown>
                </div>
              </SupportOffline>
            </Nav>
          </Container>
        </Navbar>
      </header>
    </>
  );
};

export default TopHeader;
